import React, { useState, useEffect } from "react";
import GameSelector from "../components/GameSelector";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const [name, setName] = useState("");
  const [nameSet, setNameSet] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const savedName = localStorage.getItem("spyfallName");
    if (savedName) {
      setName(savedName); // Set the saved name
      setNameSet(true); // Name is set, skip input
    }
  }, []);
  
  const handleSetName = () => {
    if (!name.trim()) return alert("Please enter your name.");
    localStorage.setItem("spyfallName", name);
    setNameSet(true);
  };

  const handleGameSelect = (game) => {
    navigate(`/${game}`);
  };

    return (
    <div style={styles.container}>
      <h1>🎮 Welcome to Game Lobby</h1>

      {!nameSet ? (
        <>
          <button style={styles.crosswordButton} onClick={() => navigate("/crossword")}>
            🧩 Igraj Crossword (bez logina)
          </button>
          <p style={styles.orText}>ili unesi ime za ostale igre</p>
          <input
            style={styles.input}
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <br />
          <button style={styles.setNameButton} onClick={handleSetName}>
            ✅ Set Name
          </button>
        </>
      ) : (
        <>
          <p style={styles.nameInfo}>Welcome, <strong>{name}</strong>!</p>
          <GameSelector onSelect={handleGameSelect} />
        </>
      )}
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    marginTop: "5rem",
    fontFamily: "sans-serif",
  },
  input: {
    padding: "0.6rem",
    fontSize: "1rem",
    width: "60%",
    maxWidth: "300px",
    marginBottom: "1rem",
  },
  setNameButton: {
    padding: "0.6rem 1.2rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#4CAF50",
    color: "#fff",
    cursor: "pointer",
  },
  crosswordButton: {
    padding: "0.7rem 1.2rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "none",
    backgroundColor: "#6f42c1",
    color: "#fff",
    cursor: "pointer",
    marginBottom: "0.8rem",
  },
  orText: {
    margin: "0 0 1rem",
    color: "#555",
  },
  nameInfo: {
    fontSize: "1.2rem",
    marginBottom: "2rem",
  },
};